"use strict";

var _classCallCheck = require("/opt/atlassian/pipelines/agent/build/node_modules/gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/atlassian/pipelines/agent/build/node_modules/gatsby/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Move = void 0;

var Attract_1 = require("./Attract");

var Enums_1 = require("../../../../Enums");

var Trail_1 = require("./Trail");

var Path_1 = require("./Path/Path");

var MoveAngle_1 = require("./MoveAngle");

var MoveGravity_1 = require("./MoveGravity");

var OutModes_1 = require("./OutModes");

var Utils_1 = require("../../../../Utils");

var Spin_1 = require("./Spin");

var Move = /*#__PURE__*/function () {
  function Move() {
    _classCallCheck(this, Move);

    this.angle = new MoveAngle_1.MoveAngle();
    this.attract = new Attract_1.Attract();
    this.decay = 0;
    this.distance = {};
    this.direction = Enums_1.MoveDirection.none;
    this.drift = 0;
    this.enable = false;
    this.gravity = new MoveGravity_1.MoveGravity();
    this.path = new Path_1.Path();
    this.outModes = new OutModes_1.OutModes();
    this.random = false;
    this.size = false;
    this.speed = 2;
    this.spin = new Spin_1.Spin();
    this.straight = false;
    this.trail = new Trail_1.Trail();
    this.vibrate = false;
    this.warp = false;
  }

  _createClass(Move, [{
    key: "collisions",
    get: function get() {
      return false;
    },
    set: function set(value) {}
  }, {
    key: "bounce",
    get: function get() {
      return this.collisions;
    },
    set: function set(value) {
      this.collisions = value;
    }
  }, {
    key: "out_mode",
    get: function get() {
      return this.outMode;
    },
    set: function set(value) {
      this.outMode = value;
    }
  }, {
    key: "outMode",
    get: function get() {
      return this.outModes.default;
    },
    set: function set(value) {
      this.outModes.default = value;
    }
  }, {
    key: "noise",
    get: function get() {
      return this.path;
    },
    set: function set(value) {
      this.path = value;
    }
  }, {
    key: "load",
    value: function load(data) {
      var _a, _b, _c;

      if (data === undefined) {
        return;
      }

      if (data.angle !== undefined) {
        if (typeof data.angle === "number") {
          this.angle.value = data.angle;
        } else {
          this.angle.load(data.angle);
        }
      }

      this.attract.load(data.attract);

      if (data.decay !== undefined) {
        this.decay = data.decay;
      }

      if (data.direction !== undefined) {
        this.direction = data.direction;
      }

      if (data.distance !== undefined) {
        this.distance = typeof data.distance === "number" ? {
          horizontal: data.distance,
          vertical: data.distance
        } : Utils_1.deepExtend({}, data.distance);
      }

      if (data.drift !== undefined) {
        this.drift = Utils_1.setRangeValue(data.drift);
      }

      if (data.enable !== undefined) {
        this.enable = data.enable;
      }

      this.gravity.load(data.gravity);
      var outMode = (_a = data.outMode) !== null && _a !== void 0 ? _a : data.out_mode;

      if (data.outModes !== undefined || outMode !== undefined) {
        if (typeof data.outModes === "string" || data.outModes === undefined && outMode !== undefined) {
          this.outModes.load({
            default: (_b = data.outModes) !== null && _b !== void 0 ? _b : outMode
          });
        } else {
          this.outModes.load(data.outModes);
        }
      }

      this.path.load((_c = data.path) !== null && _c !== void 0 ? _c : data.noise);

      if (data.random !== undefined) {
        this.random = data.random;
      }

      if (data.size !== undefined) {
        this.size = data.size;
      }

      if (data.speed !== undefined) {
        this.speed = Utils_1.setRangeValue(data.speed);
      }

      this.spin.load(data.spin);

      if (data.straight !== undefined) {
        this.straight = data.straight;
      }

      this.trail.load(data.trail);

      if (data.vibrate !== undefined) {
        this.vibrate = data.vibrate;
      }

      if (data.warp !== undefined) {
        this.warp = data.warp;
      }
    }
  }]);

  return Move;
}();

exports.Move = Move;